module.exports = __webpack_public_path__ + "img/orlova (2).84356f39.jpg";